import { FetchState } from './reducerFor'

const fetchSelectors = <T, S>(getAll: (state: S) => FetchState<T>) => {
  return {
    isFetching: (state: S): boolean => getAll(state).isFetching,
    resources: (state: S): T | undefined => getAll(state).resources,
    error: (state: S): any => getAll(state).error
  }
}

export default fetchSelectors
